import { Equal }		from "ts-base/equal";
import { Monoid }		from "ts-base/monoid";
import { Comparator }	from "ts-base/comparator";

export namespace Booleans {
	export const not	= (it:boolean):boolean	=> !it;
	export const and	= (a:boolean, b:boolean):boolean	=> a && b;
	export const or		= (a:boolean, b:boolean):boolean	=> a || b;

	//-----------------------------------------------------------------------------
	//## typeclasses

	export const equal:Equal<boolean>			= Equal.builtin;
	export const compare:Comparator<boolean>	= Comparator.builtin;

	export const conjunction:Monoid<boolean>	= {
		empty:	true,
		concat:	and,
	};

	export const disjunction:Monoid<boolean>	= {
		empty:	false,
		concat:	or,
	};

	// aliases for backwards compatibility
	export const andMonoid	= conjunction;
	export const orMonoid	= disjunction;
}
